import { EndorsementPremiumChange } from '@root/@types/types';

export function getConditionalPremiumLabel(premium_change?: EndorsementPremiumChange): string {
  const labels: Record<EndorsementPremiumChange, string> = {
    [EndorsementPremiumChange.ADDITION]: 'Additional premium to collect',
    [EndorsementPremiumChange.RETURN]: 'Return premium to provide',
    [EndorsementPremiumChange.NONE]: '',
  };
  return premium_change ? labels[premium_change] : '';
}
